import LoadingView from '@components/atoms/loading-view';

const PROGRESS_BAR_SECONDS = 20;

export const GenerateTransfers = () => (
  <LoadingView
    headerText="Generating new transfers"
    loadingText={`This may take up to ${PROGRESS_BAR_SECONDS} seconds`}
    progressBarSeconds={PROGRESS_BAR_SECONDS}
  />
);
